import React from "react";
import cn from "clsx";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import { TOAST_SEVERITY } from "static/constants";
import "./toastStyle.css";

const ToastContent = ({
  message,
  type = TOAST_SEVERITY.SUCCESS,
  undoAction,
}) => {
  const toastTitle = {
    [TOAST_SEVERITY.SUCCESS]: "Success",
    [TOAST_SEVERITY.WARNING]: "Warning",
    [TOAST_SEVERITY.ERROR]: "Error",
    [TOAST_SEVERITY.INFO]: "Info",
  };

  const variantIcon = {
    [TOAST_SEVERITY.SUCCESS]: CheckCircleIcon,
    [TOAST_SEVERITY.WARNING]: WarningIcon,
    [TOAST_SEVERITY.ERROR]: ErrorIcon,
    [TOAST_SEVERITY.INFO]: InfoIcon,
  };

  const classNameOfIndicator = "indicator--" + type;
  const Icon = variantIcon[type];
  const title = toastTitle[type || "success"];

  const undoHtml = (
    <div
      onClick={() => {
        undoAction();
      }}
      style={{
        marginLeft: "10px",
        color: "blue",
        cursor: "pointer",
        width: "44px",
        marginRight: "10px",
        textAlign: "center",
        textDecoration: "underline",
      }}
    >
      Undo
    </div>
  );

  const undo = typeof undoAction === "function" ? undoHtml : "";

  return (
    <div
      className={cn(classNameOfIndicator, "d-flex")}
      style={{ alignItems: "center", padding: "10px" }}
    >
      <div className="toastify-message-container">
        <div className="toastify-icon">
          <Icon />
        </div>
        <div className="toastify-body">
          <h3 className="toast-title">{title}</h3>
          <p className="toast-message">{message}</p>
        </div>
      </div>
      {undoAction && <div>{undo}</div>}
    </div>
  );
};

export default ToastContent;
